// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contract-compute-wrapper .el-row[data-v-e8985798]{margin:0 calc(0px - var(--base-size-16))}.contract-compute-wrapper .el-row .el-col[data-v-e8985798]{padding:0 var(--base-size-16)}", ""]);
// Exports
module.exports = exports;
